import IComprovantesExtratoRequest from '../entities/IComprovantesExtratoRequest'
import IComprovantesExtratoResponse from '../entities/IComprovantesExtratoResponse'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IComprovantesExtrato {
  execute(
    params: IComprovantesExtratoRequest,
  ): Promise<IComprovantesExtratoResponse>
}

export default class ComprovantesExtratoImpl implements IComprovantesExtrato {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(
    params: IComprovantesExtratoRequest,
  ): Promise<IComprovantesExtratoResponse> {
    return this.pagamentosRepository.comprovantesExtrato(params)
  }
}
